import gql from 'graphql-tag'

export const organizationInfoFragment = gql`
  fragment OrganizationInfo on Organization {
    id
    name
    slug
    aiFeatures {
      feature
      enabled
    }
  }
`
